import ApiService from '@/common/api.service'

export default {
  sendMemberRegistrationMailWeb (mail) {
    return new Promise((resolve, reject) => {
      ApiService.query('/mail/sendMemberRegistrationMailWeb?apply=' + mail).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
